export default __webpack_public_path__ + "static/media/tyRed.a234f3b3.svg";